import React, {FC, ReactElement} from "react";
import {Button, Grid} from "@mui/material";
import LoadingButton from "../../../components/button/LoadingButton";
import {observer} from "mobx-react";
import {newEmployeeWizardState, TaxResidenceCountryType} from "../../../store/NewEmployeeWizardState";
import {ControlDivider} from "./NewEmployeeWizard";
import FileInput from "../../../components/file/FileInput";
import {Trans, useTranslation} from "react-i18next";

interface IProps {
    handleBack: () => void
    handleNext: () => void
}

export const DocumentsUploadSection: FC<IProps> = observer(({handleNext, handleBack}): ReactElement => {
    const passportNeeded = newEmployeeWizardState.allowedToWorkByCitizenship === true;
    const workPermitNeeded = newEmployeeWizardState.allowedToWorkByCitizenship !== true;
    const taxResidenceStatementNeeded = newEmployeeWizardState.taxResidenceCountryType === TaxResidenceCountryType.DONT_KNOW;
    const taxDeductionNeeded = newEmployeeWizardState.taxDeductionNeeded === true;

    const nextDisabled =
            (passportNeeded && !newEmployeeWizardState.document) ||
            (workPermitNeeded && !newEmployeeWizardState.workPermitDocument) ||
            (taxResidenceStatementNeeded && !newEmployeeWizardState.taxResidenceStatementDocument) ||
            (taxDeductionNeeded && !newEmployeeWizardState.taxDeductionFormDocument) ||
            !newEmployeeWizardState.workContractDocument ||
            false;

    const {t} = useTranslation()

    return <>
        <Grid container spacing={2}>
            {passportNeeded &&
                    <Grid item xs={12}>
                        <FileInput
                                label={t("new_employee.document_upload.document", "Employee document (passport or ID card)")}
                                required={true}
                                value={newEmployeeWizardState.document}
                                onChange={value => newEmployeeWizardState.document = value}
                        />
                    </Grid>
            }
            {workPermitNeeded &&
                    <Grid item xs={12}>
                        <FileInput
                                label={t("new_employee.document_upload.work_permit", "Document that confirms the right to work (residence card or D-visa)")}
                                required={true}
                                value={newEmployeeWizardState.workPermitDocument}
                                onChange={value => newEmployeeWizardState.workPermitDocument = value}
                        />
                    </Grid>
            }
            {taxResidenceStatementNeeded &&
                    <Grid item xs={12}>
                        <FileInput
                                label={t("new_employee.document_upload.tax_residence", "Tax residence statement")}
                                required={true}
                                value={newEmployeeWizardState.taxResidenceStatementDocument}
                                onChange={value => newEmployeeWizardState.taxResidenceStatementDocument = value}
                        />
                    </Grid>
            }
            {taxDeductionNeeded &&
                    <Grid item xs={12}>
                        <FileInput
                                label={t("new_employee.document_upload.tax_deduction", "Signed tax deduction form")}
                                required={true}
                                value={newEmployeeWizardState.taxDeductionFormDocument}
                                onChange={value => newEmployeeWizardState.taxDeductionFormDocument = value}
                        />
                    </Grid>
            }
            <Grid item xs={12}>
                <FileInput
                        label={t("new_employee.document_upload.work_contract", "Signed work contract")}
                        required={true}
                        value={newEmployeeWizardState.workContractDocument}
                        onChange={value => newEmployeeWizardState.workContractDocument = value}
                />
            </Grid>
        </Grid>
        <ControlDivider/>
        <Grid container spacing={1}>
            <Grid item>
                <Button variant="contained" color="secondary" onClick={handleBack}><Trans i18nKey="common.back">Back</Trans></Button>
            </Grid>
            <Grid item>
                <LoadingButton disabled={nextDisabled} variant="contained" color="primary" onClick={handleNext}><Trans i18nKey="common.next">Next</Trans></LoadingButton>
            </Grid>
        </Grid>
    </>
});

export default DocumentsUploadSection;